const SET_PRODUCTS = "playground/SET_PRODUCTS";
const CLEAR_PRODUCTS = "playground/CLEAR_PRODUCTS";
const SET_MUTATIONS = "playground/SET_MUTATIONS";
const CLEAR_MUTATIONS = "playground/CLEAR_MUTATIONS";
const SET_PLAY_PROFILE = "playground/SET_PLAY_PROFILE";
const CLEAR_PLAY_PROFILE = "playground/CLEAR_PLAY_PROFILE";
const SET_HAS_PLAY_PROFILE = "playground/SET_HAS_PLAY_PROFILE";
const SET_MISSIONS = "playground/SET_MISSIONS";
const SET_STANDINGS = "playground/SET_STANDINGS";

const INITIAL_STATE = {
  products: null,
  mutations: null,
  missions: null,
  hasPlayProfile: false,
  playProfile: null,
  standings: null,
};

export default function cashierReducer(state, action) {
  switch (action.type) {
    case SET_PRODUCTS:
      return {
        ...state,
        products: action.payload,
      };
    case CLEAR_PRODUCTS:
      return {
        ...state,
        products: null,
      };
    case SET_MUTATIONS:
      return {
        ...state,
        mutations: action.payload,
      };
    case CLEAR_MUTATIONS:
      return {
        ...state,
        mutations: null,
      };
    case SET_PLAY_PROFILE:
      return {
        ...state,
        playProfile: action.payload,
      };
    case CLEAR_PLAY_PROFILE:
      return {
        ...state,
        playProfile: null,
      };
    case SET_HAS_PLAY_PROFILE:
      return {
        ...state,
        hasPlayProfile: action.payload,
      };
    case SET_MISSIONS:
      return {
        ...state,
        missions: action.payload,
      };
    case SET_STANDINGS:
      return {
        ...state,
        standings: action.payload,
      };
    default:
      return state === undefined ? INITIAL_STATE : state;
  }
}

export const playgroundAction = {
  setPlayProfile: playProfile => ({
    type: SET_PLAY_PROFILE,
    payload: playProfile,
  }),
  clearPlayProfile: () => ({
    type: CLEAR_PLAY_PROFILE,
  }),
  setProducts: products => ({
    type: SET_PRODUCTS,
    payload: products,
  }),
  clearProducts: () => ({
    type: CLEAR_PRODUCTS,
  }),
  setMutations: mutations => ({
    type: SET_MUTATIONS,
    payload: mutations,
  }),
  clearMutations: () => ({
    type: CLEAR_MUTATIONS,
  }),
  hasPlayProfile: () => ({
    type: SET_HAS_PLAY_PROFILE,
    payload: true,
  }),
  hasNotPlayProfile: () => ({
    type: SET_HAS_PLAY_PROFILE,
    payload: false,
  }),
  setMissions: missions => ({
    type: SET_MISSIONS,
    payload: missions,
  }),
  setStandings: standings => ({
    type: SET_STANDINGS,
    payload: standings,
  }),
};
